import {getTestProps} from '@benchling/js-test-utils';
import {Group, Stack, Text} from '@mantine/core';
import React from 'react';

import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import SkillsList from 'llm/chat-library/skills/SkillsList';
import UploadSkillModal from 'llm/chat-library/skills/UploadSkillModal';
import useSkills from 'llm/chat-library/skills/useSkills';
import EntityStore from 'stores/EntityStore';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';
import {CenteredSpinner} from 'ui-library/Spinner';

export default function AISettingsSkills(): JSX.Element {
  const {llmEnableSkills: skillsEnabled} = useRolloutFlags();
  const {
    skills,
    isLoading: skillsLoading,
    archiveSkill,
    createNewSkills,
  } = useSkills({
    enabled: skillsEnabled,
  });
  const isTenantAdmin = EntityStore.currentUser()?.isTenantAdmin ?? false;

  return (
    <Stack spacing={16} sx={{flex: '1 1 auto', minHeight: 0, overflow: 'hidden'}}>
      <Stack spacing={8}>
        <Group noWrap={true} position="apart" align="center">
          <Text fw="bold" size="xl">
            Skills
          </Text>
          <Button
            buttonStyle={ButtonStyle.SECONDARY}
            icon="plus"
            onClick={() => {
              runModal(UploadSkillModal, {
                onRequestSubmit: createNewSkills,
              });
            }}
            size={ButtonSize.SMALL}
            text="Add"
            {...getTestProps({component: 'AISettingsSkills', element: 'uploadSkillButton'})}
          />
        </Group>
        <Text fw="normal" size="sm" c="dimmed">
          Reusable instructions shared across your organization.
        </Text>
      </Stack>
      {skillsLoading ? (
        <CenteredSpinner />
      ) : (
        <SkillsList skills={skills} isTenantAdmin={isTenantAdmin} onArchive={archiveSkill} />
      )}
    </Stack>
  );
}
